(function () {
  function injectModal() {
    if (!document.getElementById('personalised-label-modal')) {
      const modalHTML = `
        <div id="personalised-label-modal" class="reco-modal personalised-label-modal reco-hidden" role="dialog" aria-modal="true" aria-label="Product information">
          <div class="reco-modal-content">
            <div class="reco-modal-message">
              <p>Always read the label before adding new products to your pack. Always follow the directions for use.</p>
            </div>
            <div class="reco-modal-actions">
              <button id="label-modal-continue" class="reco-btn">Continue</button>
            </div>
          </div>
        </div>
      `;
      document.body.insertAdjacentHTML('beforeend', modalHTML);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectModal);
  } else {
    injectModal();
  }

  window.personalised = window.personalised || {};
  window.personalised.labelModal = {
    showLabelModal: function () {
      return new Promise((resolve) => {
        const modal = document.getElementById('personalised-label-modal');
        if (!modal) {
          return resolve(true);
        }

        modal.classList.remove('reco-hidden');

        const continueBtn = modal.querySelector('#label-modal-continue');
        const handleContinue = () => {
          modal.classList.add('reco-hidden');
          continueBtn.removeEventListener('click', handleContinue);
          resolve(true);
        };
        
        continueBtn.addEventListener('click', handleContinue);
      });
    }
  };
})();